import { createAction, createReducer } from '@reduxjs/toolkit';
import { firstDayOfMonth, today } from '../../../../../utils/dates';
import { IInitialState } from './interface';

const INITIAL_STATE: IInitialState = {
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  partner: 'global',
  fare: 'receita',
  account: 'todos',
  initialDate: firstDayOfMonth(),
  finalDate: today(),
  searched: {
    partner: 'global',
    fare: 'boleto',
    account: 'todos',
    initialDate: firstDayOfMonth(),
    finalDate: today(),
  },
};

export const settingFilter = createAction('@faresApp/filter/SETTING_FILTER');

export const setPartnerFilterOptions = createAction<any>(
  '@faresApp/filter/SET_PARTNER_FILTER_OPTION'
);
export const setFareFilterOptions = createAction<any>(
  '@faresApp/filter/SET_FARE_FILTER_OPTION'
);
export const setAccountFilterOptions = createAction<any>(
  '@faresApp/filter/SET_ACCOUNT_FILTER_OPTION'
);
export const setInitialDateFilterOptions = createAction<any>(
  '@faresApp/filter/SET_INITIAL_DATE_FILTER_OPTION'
);
export const setFinalDateFilterOptions = createAction<any>(
  '@faresApp/filter/SET_FINAL_DATE_FILTER_OPTION'
);
export const setSearched = createAction<any>('@faresApp/filter/SET_SEARCHED');

export const gotError = createAction('@faresApp/filter/GOT_ERROR');

const faresFilterReducer = createReducer(INITIAL_STATE, {
  [settingFilter.type]: (state) => ({
    ...state,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [setPartnerFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    partner: action.payload,
  }),
  [setFareFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    fare: action.payload,
  }),
  [setAccountFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    account: action.payload,
  }),
  [setInitialDateFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    initialDate: action.payload,
  }),
  [setFinalDateFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    finalDate: action.payload,
  }),
  [setSearched.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    searched: {
      partner: action.payload.partner,
      fare: action.payload.fare,
      account: action.payload.account,
      initialDate: action.payload.initialDate,
      finalDate: action.payload.finalDate,
    },
  }),
  [gotError.type]: (state) => ({
    ...state,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
});

export default faresFilterReducer;
